import { BaseSyntheticEvent, useState } from "react";
import hash from "object-hash";

import "./Dropdown.scss";
import HelpIcon from "../../assets/help-icon.png";
import CloseIcon from "../../assets/close-icon.png";

import { Placeholder } from "../Typography";
import Option from "../../types/Option";

interface Props {
  title?: string;
  options: Option[];
  placeholder?: string;
  className?: string;
  helpContent?: any;
  onChange?: any;
  value?: any;
  error?: string;
}

export const Dropdown = ({
  title,
  options,
  className,
  helpContent,
  onChange,
  value,
  error
}: Props) => {
  const [helpFadeOut, setHelpFadeOut] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const formattedOptions: Option[] = [{ value: null, text: "——————" }, ...options];

  const onClickHelp = () => {
    setHelpOpen(true);
  };

  const onClickHelpClose = () => {
    setHelpFadeOut(true);

    setTimeout(() => {
      setHelpOpen(false);
      setHelpFadeOut(false);
    }, 500);
  };

  const onChangeSelect = (e: BaseSyntheticEvent) => {
    const selectedValue: Option[] = options.filter(
      (item) => item.value == e?.target?.value
    );

    if (onChange && selectedValue && selectedValue.length > 0) {
      onChange(selectedValue[0]);
    }
  };

  return (
    <div className={`dropdown ${className ? className : ""}`}>
      <div className="dropdown-title">
        {title && <Placeholder>{title}</Placeholder>}
        {helpContent && (
          <img
            className="help-icon"
            alt=""
            src={HelpIcon}
            onClick={onClickHelp}
          />
        )}
        {error && <span className="error-text">{error}</span>}
      </div>

      <select className={`select ${error ? "select-error" : ""}`} value={value} onChange={onChangeSelect}>
        {formattedOptions.map((option, index) => (
          <option key={hash({option, index})} value={option.value}>
            {option.text}
          </option>
        ))}
      </select>

      {helpContent && helpOpen && (
        <div
          className={`help-popover animate__animated animate__faster animate__fadeIn ${
            helpFadeOut && "animate__fadeOut"
          }`}
        >
          <img
            className="close-icon"
            alt=""
            src={CloseIcon}
            onClick={onClickHelpClose}
          />
          <div className="content">{helpContent}</div>
        </div>
      )}
    </div>
  );
};
